export default {
  energySection: {
    title: {
      fr: "Réduisez vos factures et\n votre empreinte énergétique.",
      en: "Reduce your energy bills\n and your environment footprint.",
    },
    subtitle: {
      fr: "",
      en: "",
    },
    features: {
      title: {
        fr: "",
        en: "",
      },
      items: {
        solarPanels: {
          title: {
            fr: "Exploitez pleinement l’énergie de vos panneaux solaires.",
            en: "Make the most of your solar energy",
          },
          description: {
            fr: "Le Edge Computer exécute localement des algorithmes auto-apprenants pour exploiter l’énergie produite par vos panneaux solaires, par exemple pour déclencher un ballon d’eau chaude ou la recharge d’un véhicule.",
            en: "The Edge Computer runs self-learning algorithms locally to optimize your solar production, for example by triggering a water heater or charging a vehicle.",
          },
        },

        energyGraphs: {
          title: {
            fr: "Visualisez vos efforts dans l’onglet Energie.",
            en: "Visualize your energy performance",
          },
          description: {
            fr: "Suivez l’évolution de la consommation et de la production d’énergie, que ce soit pour un équipement ou pour un groupe d’équipements.",
            en: "Track energy consumption and production, whether for a single device or a group of devices.",
          },
        },

        enedis: {
          title: {
            fr: "",
            en: "",
          },
          description: {
            fr: "Ajoutez également votre compteur Linky résidentiel pour une vision globale de votre consommation.",
            en: "Add your residential Linky smart meter for a complete overview of your energy consumption.",
          },
        },
      },
    },
  },
};
